const activities = [
  { name: 'Crunches', groups: ['core'] },
  { name: 'Plank', groups: ['core'] },
  { name: 'Side Plank', groups: ['core'] },
  { name: 'Scissors', groups: ['core'] },
  { name: 'Penguin', groups: ['lower'] },
  { name: 'Lunges', groups: ['lower'] },
  { name: 'High Knees', groups: ['lower'] },
  { name: 'Mountain Climber', groups: ['core', 'lower'] },
  { name: 'Back Leg Lifts', groups: ['lower'] },
  { name: 'Squats', groups: ['lower'] },
  { name: 'Push Ups', groups: ['core', 'upper'] },
  { name: 'Plank Rotation', groups: ['core', 'upper'] },
  { name: 'Chest Squeeze', groups: ['core', 'upper'] },
  { name: 'Push Ups', groups: ['core', 'upper'] },
  { name: 'Tricep Dips', groups: ['core', 'upper'] },
  { name: 'Bicep Curls', groups: ['upper'] },
  { name: 'Touch Toes Crossover', groups: ['core'] },
  { name: 'Back Extensions', groups: ['core'] },
  { name: 'Forward Bends', groups: ['core'] },
  { name: 'Quick Steps', groups: ['fast', 'lower'] },
  { name: 'Quick Steps In/Out', groups: ['fast', 'lower'] },
  { name: 'Sidesteps', groups: ['fast', 'lower'] },
  { name: 'Sidesteps Crossover', groups: ['fast', 'lower'] },
  { name: 'Sidesteps T Box', groups: ['fast', 'lower'] },
  { name: 'Bunny Hops', groups: ['fast', 'lower'] },
  { name: 'Box Jumps', groups: ['lower'] },
  { name: 'Step Ups', groups: ['lower'] },
  { name: 'Arm Swings Across Chest', groups: ['upper'] },
  { name: 'Arm Small Circles', groups: ['upper'] },
  { name: 'Arm Big Circles', groups: ['upper'] },
  { name: 'Speed Bag Punches ', groups: ['upper', 'fast'] },
  { name: 'Shadow Boxing ', groups: ['upper', 'lower', 'core', 'fast'] },
  { name: 'Front Back Punches ', groups: ['upper', 'core', 'fast'] },
  { name: 'Split-Step Swing', groups: ['upper', 'lower', 'fast'] },
]

export { activities }
